import { useEffect, useState } from "react";
import axios from "axios";
import BoardMembersEditor from "./BoardMembersEditor";
import { confirmSwal } from "../utils/confirm";

import { auth } from "../firebase";

export default function AdminExecutiveBoard() {
    const [board, setBoard] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newName, setNewName] = useState("");

    useEffect(() => {
        const fetchBoard = async () => {
            try {
                const token = await auth.currentUser.getIdToken();
                const res = await axios.get("/api/board", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setBoard(res.data);
            } catch (error) {
                console.error("Error fetching board:", error);
                alert("Error fetching board");
            } finally {
                setLoading(false);
            }
        };
        
        fetchBoard();
    }, []);

    const addBoardRole = async () => {
        if (!newName.trim()) return alert("Board role name cannot be empty");

        try {
            const token = await auth.currentUser.getIdToken();
            const res = await axios.post("/api/board", { name: newName.trim() }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setBoard([res.data, ...board]);
            setNewName("");
        } catch {
            alert("Error adding board role");
        }
    };

    const deleteBoardRole = async (id, name) => {
        const ok = await confirmSwal({
            title: `Delete board role ${name}?`,
            text: "Once deleted it cannot be restored.",
            icon: "warning",
            confirmText: "Delete",
            confirmColor: "#d33",
        });
        if (!ok) return;

        try {
            const token = await auth.currentUser.getIdToken();
            await axios.delete(`/api/board/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setBoard(board.filter(c => c._id !== id));
        } catch {
            alert("Error deleting board role");
        }
    };

    if (loading) return <p>Loading board...</p>;

    return (
        <div className="container">
            <p className="text-body-secondary">Similar to the Committees tab, this is where you can create executive roles to assign to those in the Directory.</p>

            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="New role name"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                />
                <button className="btn btn-admin" onClick={addBoardRole}>
                    +
                </button>
            </div>

            <ul className="list-group">
                {board.map((c) => (
                    <li key={c._id} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <strong>{c.name}</strong>
                            <button className="btn btn-outline-secondary btn-sm" onClick={() => deleteBoardRole(c._id, c.name)}>
                                Delete
                            </button>
                        </div>

                        <BoardMembersEditor board_role={c} />
                    </li>
                ))}
            </ul>

        </div>
    );
}